module.exports = __webpack_public_path__ + "media/images/application/template/tick-87ebb509d77d0179b84c0b16e8844c59.svg";